import { Component, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
    AreaMappingHubData,
    SimulationMappingData,
    SimulationStaticLeftWbs,
    SimulationStaticRightWbs,
    selectDataHubInfo,
    selectDataHub,
} from './data'
import { FormsModule } from '@angular/forms'
import { IsIgxDialogComponent, IsIgxHubComponent, IsIgxMappingComponent, WbsFrontend } from '@interserve/igx-angular'
import { IgxButtonModule } from '@infragistics/igniteui-angular'
@Component({
    selector: 'is-igx-wbs-sample',
    standalone: true,
    templateUrl: './is-igx-wbs-sample.component.html',
    styleUrl: './is-igx-wbs-sample.component.scss',
    imports: [
        CommonModule,
        FormsModule,
        IsIgxMappingComponent,
        IsIgxHubComponent,
        IsIgxDialogComponent,
        IgxButtonModule,
    ],
})
export class IsIgxWbsSampleComponent {
    @ViewChild('selectDataHub', { static: true }) public selectDataHub: IsIgxHubComponent | undefined
    constructor() {}
    loading = true

    //物流改善
    StaticLeftWbsData: any[] = SimulationStaticLeftWbs
    StaticRightWbsData: any[] = SimulationStaticRightWbs
    mappingData: WbsFrontend | undefined = SimulationMappingData

    mappingDataString = ''
    //HUB設定（紐づけで使用）
    mappingDataHub: WbsFrontend = AreaMappingHubData
    selectTestDataHubSettings = structuredClone(selectDataHubInfo)
    staticSelectTestData = structuredClone(selectDataHub)
    
    selectTestDataHubActions = {
        select: (event: any) => {
            const selected = event.leftWbs.selected
            if (selected.length === 0) {
                alert('WBSを選択してください。')
            } else {
                console.log('WBS:', selected)
                this.selectDataHub?.close()
            }
        },
    }

    ngOnInit(): void {
        this.mappingDataString = JSON.stringify(this.mappingData, null, 2)
        this.loading = false
    }

    reflectMappingData() {
        try {
            const json = JSON.parse(this.mappingDataString)
            this.mappingData = json
        } catch (error) {
            console.error(error)
        }
    }

    openTestDataHub() {
        this.staticSelectTestData = structuredClone(selectDataHub)
        this.selectDataHub?.open()
    }
}
